import { Desglose } from "@/components/admin/Desglose";

const ESTADOS = { enviada: "Enviada", vista: "Vista", contactado: "Contactado/a", contratado: "Contratado/a", descartada: "No avanza" };

export const MetricasDesgloses = ({ m }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-6">
    <Desglose titulo="Egresados/as por programa" datos={m.egresados_por_programa} testid="m-egresados-programa" />
    <Desglose titulo="Empresas por industria/sector" datos={m.empresas_por_rubro} ocultarCeros testid="m-empresas-rubro" />
    <Desglose titulo="Búsquedas por empresa" datos={(m.busquedas_por_empresa || []).map((b) => [b.razon_social, b.busquedas])} testid="m-busquedas-empresa" />
    <Desglose titulo="Postulaciones por estado" datos={Object.entries(m.postulaciones_por_estado || {}).map(([k, n]) => [ESTADOS[k] || k, n])} testid="m-postulaciones-estado" />
    <Desglose titulo="Contrataciones por modo de contratación" datos={m.contrataciones_por_modo} testid="m-contrataciones-modo" />
    <Desglose titulo="Motivos de “No avanza”" datos={m.no_avanza_por_motivo} testid="m-no-avanza-motivo" />
  </div>
);
